import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import Firebase from "firebase/app"
import 'firebase/database'

import {parseEvents, updateDict, parseTimestamp} from '../../../utils'


class EventsSheetExporter extends Component {

    constructor(props){
        super(props)
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            reservationsFound: {},
            exportSheet: false,
            msg: ""
        }
        this.onDateChange = this.onDateChange.bind(this)
        this.onExportClick = this.onExportClick.bind(this)
        this.downloadAllReservations = this.downloadAllReservations.bind(this)
    }

    onDateChange(ref, value){
        if (ref === 'startDate'){
            this.setState({
                startDate: value
            })
            return
        }
        this.setState({
            endDate: value
        })
    }

    componentDidUpdate(){
        const {exportSheet, reservationsFound} = this.state
        if (exportSheet){
            document.getElementById("test-table-xls-button").click()
            this.setState({
                exportSheet: false,
                msg: ""
            })
        }
    }

    downloadAllReservations(currentIndex, allEventIds, allEvents, reservationsFound){
        const {downloadAllReservations} = this
        const refReservations = Firebase.database().ref('/guests')
        if (allEventIds.length <= currentIndex){
            this.setState({
                exportSheet: true,
                reservationsFound: reservationsFound
            })
            return
        }
        const currentEventId = allEventIds[currentIndex]
        refReservations.child(currentEventId).once('value', snapshot => {
            var reservations = snapshot.val()
            const eventIdFromRef = snapshot.key;
            if (reservations == null){
                reservations = {}
            }
            const res = {}
            res[eventIdFromRef] = reservations

            for(var resId in res[eventIdFromRef]) {
                // Add aditional information for reservation from events
                res[eventIdFromRef][resId]["eventName"] = allEvents[eventIdFromRef]["name"]
                res[eventIdFromRef][resId]["room"] = allEvents[eventIdFromRef]["room"]["name"]
                var guests = res[eventIdFromRef][resId]["guests"].filter(
                    guest => guest.name.length > 0).map(guestName => {return guestName.name})
                guests.push(res[eventIdFromRef][resId].personalData.name)
                res[eventIdFromRef][resId]["allGuests"] = guests.join(', ')
            }
            downloadAllReservations(
                currentIndex + 1,
                allEventIds,
                allEvents,
                updateDict(reservationsFound, res)
            )
        })
    }

    onExportClick(event){
        const {startDate, endDate } = this.state
        const { downloadAllReservations } = this
        const ref = Firebase.database().ref('/events').orderByChild('end')
            .startAt(startDate.getTime())

        ref.once('value', snapshot => {
            var eventsRaw = snapshot.val();
            if (eventsRaw === null){
                eventsRaw = {}
            }
            const availableEvents = parseEvents(eventsRaw, true)
            const foundReservations = {}
            const allEventIds = Object.keys(availableEvents)
            if (allEventIds.length > 0){
                this.setState({
                    msg: "Exportando, por favor espere..."
                })
                downloadAllReservations(0, allEventIds, availableEvents, {})
            } else {
                this.setState({
                    exportSheet: false,
                    reservationsFound: {},
                    msg: "No se encontraron eventos"
                })
            }
        })

    }

    render(){
        const { onDateChange, onExportClick} = this
        const { startDate, endDate, reservationsFound, msg } = this.state
        return(
            <div className="container-custom-event-picker">
                <div className="line-header-text">Reporte de Eventos</div>
                <div>
                    <div className="events-sheet-exporter-date-block">
                        <div> Inicio </div>
                        <div>
                            <DatePicker
                            selected={startDate}
                            disabled={false}
                            onChange={value => onDateChange('startDate', value)}
                            />
                        </div>
                    </div>
                    <div className="events-sheet-exporter-date-block">
                        <div className="events-sheet-exporter-date-block-margin"> Final </div>
                        <div>
                            <DatePicker
                            selected={endDate}
                            disabled={false}
                            onChange={value => onDateChange('endDate', value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="search-button-padding">
                    <input
                        className="button-add-reserve"
                        type="button"
                        value="Exportar"
                        onClick={onExportClick}
                        disabled={false}/>
                </div>
                <div>
                    <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-report-xls-button"
                        table="table-to-xls"
                        filename="reporte_eventos"
                        sheet="reporte_eventos"
                        buttonText="Lista de invitados como XLS"/>
                    <table id="table-to-xls" hidden>
                        <tr>
                            <th>Fecha </th>
                            <th>Hora </th>
                            <th>Fallecido </th>
                            <th>Asistentes </th>
                            <th>Sala </th>
                            <th>Telefono </th>
                            <th>Correo </th>
                        </tr>
                    {
                    Object.keys(reservationsFound).map(eventId => {
                        var result = Object.keys(reservationsFound[eventId]).map(reservationId => {
                            return (
                            <tr>
                                <td>
                                    {parseTimestamp(reservationsFound[eventId][reservationId].selectedTime).date}
                                </td>
                                <td>
                                    {parseTimestamp(reservationsFound[eventId][reservationId].selectedTime).time}
                                </td>
                                <td>
                                    {reservationsFound[eventId][reservationId].eventName}
                                </td>
                                <td>
                                    {reservationsFound[eventId][reservationId].allGuests}
                                </td>
                                <td>
                                    {reservationsFound[eventId][reservationId].room}
                                </td>
                                <td>
                                    {reservationsFound[eventId][reservationId].personalData.phone}
                                </td>
                                <td>
                                    {reservationsFound[eventId][reservationId].personalData.mail}
                                </td>
                            </tr>
                            )
                        })
                        return result
                    })
                    }
                    </table>
                    <div>
                    {
                        msg.length > 0 ?
                        <div className="events-sheet-exporter-msg">
                            {msg}
                        </div> : <div></div>
                    }
                    </div>
                </div>
            </div>
        )
    }
}

export default EventsSheetExporter
